
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.282 4a1.842 1.842 0 011.868 1.826l.001 6.122a.727.727 0 01-.222.534l.073-.084a.796.796 0 01-.073.084l-7.248 7.2a.734.734 0 01-.534.22L6.118 19.9a1.845 1.845 0 01-1.868-1.818V5.804A1.84 1.84 0 016.107 4zm.022 1.5H6.096a.339.339 0 00-.346.32v12.246a.344.344 0 00.357.334h5.295v-5.923c.004-.295.109-.577.294-.803l.099-.108a1.29 1.29 0 01.91-.366h5.945V5.836c0-.045-.01-.089-.028-.13l-.032-.058-.043-.051a.342.342 0 00-.243-.097zM12.9 12.7v4.648L17.58 12.7h-4.679z","fill":"#008CE1","fill-rule":"nonzero"}})])
          )
        }
      }
    